/*
 * @Description: 个人报表全部导出，需要searchQuery参数
 * @LastEditors: wjx
 * @Date: 2020-12-02 10:33:04
 */
import { personalBI } from '@/api/ajax';

// 项目类型对应接口
const ajaxMap = {
  5: {
    batch: personalBI.hzdyIdYEport,
    all: personalBI.hzdyAllYEport
  },
  6: {
    batch: personalBI.num6,
    all: personalBI.num6
  },
  7: {
    batch: personalBI.hzdyIdYEport,
    all: personalBI.hzdyAllYEport
  },
  8: {
    batch: personalBI.DocBlIdEport,
    all: personalBI.DocBlAllYEport
  },
  17: {
    batch: personalBI.num17,
    all: personalBI.num17
  },
  18: {
    batch: personalBI.startCaseBiDownloadTaskByIds,
    all: personalBI.startCaseBiDownloadTask
  },
  19: {
    batch: personalBI.startBiDownloadTask,
    all: personalBI.startAgreementServiceBiDownloadTask
  },
  20: {
    batch: personalBI.kpzIdYEport,
    all: personalBI.kpzAllYEport
  }
};

// 提交数据整理
const formatQuery = query => {
  let _query = {
    ...query,
    agentName: query.agentName || query.fullName,
    fullName: query.fullName || query.agentName
  };
  return _query;
};
// 使用接口判断
const setAjax = (projectType, eventType) => {
  return (ajaxMap[projectType] || {
    batch: personalBI.addVisitBIZipTask,
    all: personalBI.addVisitBIZipTask
  })[eventType];
};

// 批量提交时的参数
const detailIdsFormat = (selection, key) => {
  return selection
    .map(item => {
      return item[key];
    })
    .join(',');
};
/**
 * @description:
 * @param {string} eventType batch批量，all全部
 * @return {*}
 */
export default function(eventType) {
  let {
    $refs,
    $store,
    $route,
    $message,
    $prompt,
    $confirm,
    searchQuery
  } = this;
  let {
    projectName,
    projectType,
    id: projectId,
    projectStructureType
  } = $store.state.homeProject;
  // 需要获取数据的key
  let defaultIdKey = [5, 20, 21].includes(projectType)
    ? 'questionnaireAnswerId'
    : 'id';
  let detailIds;
  try {
    detailIds = detailIdsFormat($refs.recordList.selection, defaultIdKey);
  } catch (e) {}
  let taskMonth = $route.query.taskMonth;
  // 输入框默认值
  let inputValue = `${taskMonth}_${projectName}`;
  if (eventType === 'batch' && !detailIds) {
    $message({
      type: 'error',
      message: '请选择需要下载的数据'
    });
    return false;
  }
  // 提交数据
  let sendData = formatQuery({
    ...(eventType === 'batch' ? { detailIds } : {}),
    ...searchQuery,
    taskDt: taskMonth,
    taskDates: taskMonth,
    type: projectType,
    projectId,
    projectStructureType,
    userType: projectStructureType !== 1 ? 4 - projectStructureType : 1
  });
  // 提交接口
  let ajax = setAjax(projectType, eventType);
  let promptTitle = `个人BI报表${eventType === 'all' ? '全部' : ''}导出`;
  $prompt('自定义文件名', promptTitle, {
    closeOnClickModal: false,
    confirmButtonText: '保存',
    showCancelButton: false,
    inputErrorMessage: '请填写4~100位字符（汉字、数字、英文、-、_）做为文件名',
    inputValue,
    inputPattern: /^[A-Za-z0-9\u4E00-\u9FA5-_]{4,100}$/,
    async beforeClose(action, instance, done) {
      if (action === 'confirm') {
        instance.confirmButtonLoading = true;
        instance.confirmButtonText = '执行中...';
        let data = {
          ...sendData,
          zipName: instance.inputValue,
          downloadName: instance.inputValue
        };
        try {
          await ajax(data);
          done();
        } catch (e) {}
        instance.confirmButtonText = '保存';
        instance.confirmButtonLoading = false;
      } else {
        done();
      }
    }
  })
    .then(async () => {
      $confirm('文件已经在下载中心内进行生成,如需下载请前往下载中心', '', {
        showCancelButton: false,
        showConfirmButton: false
      }).then(() => {});
    })
    .catch(() => {});
}
